import type { EntityConfig } from '../types'

export const uprdrBatchEntity: EntityConfig = {
  id: 'uprdr-batch',
  displayName: 'Uprdr Batch',
  status: {
    filters: [
      { value: 'all', label: 'All' },
      { value: 'completed', label: 'Completed' },
      { value: 'in_progress', label: 'In Progress' },
      { value: 'pending', label: 'Pending' },
      { value: 'failed', label: 'Failed' },
    ],
    options: [
      { value: 'completed', label: 'Completed', color: 'success' },
      { value: 'in_progress', label: 'In Progress', color: 'info' },
      { value: 'pending', label: 'Pending', color: 'neutral' },
      { value: 'failed', label: 'Failed', color: 'error' },
    ],
    mappings: {
      all: [],
      completed: ['completed'],
      in_progress: ['in_progress'],
      pending: ['pending'],
      failed: ['failed'],
    },
  },
  queryFields: {
    status: { type: 'status_array', urlKey: 'status' },
    dateRange: { type: 'date_range', urlKey: 'date' },
    network: { type: 'string_array', urlKey: 'network' },
    search: { type: 'search', urlKey: '$s' },
  },
  uiFilterFields: ['search', 'status', 'dateRange', 'network'],
}
